<template>
  <div id="service_p1">
    <h1>訂房須知</h1>
    <ul>
      歡迎光臨．澎湖民宿．甜蜜小屋民宿(Sweet-Home)，為維護您的權益，訂房前請務必詳細閱讀下列內容，謝謝。
      <li>訂房時間早上 08:00 至晚上 21:00。</li>
      <li>
        訂房方式：Mobile / <a href="callto:0925-122-365">0925-122-365</a>．LINE
        ID /
        <a href="http://line.naver.jp/ti/p/wEH97e3GBb">a0925122365</a> (小靜)。
      </li>
      <li>
        旺季：每年04月～10月。淡季：每年11月～03月(農曆春節除外)。房價以來電洽詢民宿為準！或洽詢FB粉絲團：<a
          href="https://www.facebook.com/%E7%94%9C%E8%9C%9C%E5%B0%8F%E5%AE%B6%E6%B0%91%E5%AE%BF-100750528048016/"
          >甜蜜小家民宿</a
        >粉絲專頁。
      </li>
      <li>
        為維護住宿品質，房間不得超員入住，但七歲以下兒童不在此限，唯仍應於入住前告知。
      </li>
      <li>
        經確認訂房日期後，請於三日內(含訂房日當天)，以匯款轉帳方式支付房價一房1,000元作為訂金，逾期將自動取消訂房，不另通知。
      </li>
      <li>
        銀行匯款帳戶如下：
        <ul id="accountInfo">
          <li>銀行代碼：700</li>
          <li>銀行名稱：湖西隘門郵局</li>
          <li>銀行帳號：0241099-0027322</li>
          <li>帳戶名稱：陳宥靜</li>
          <li>
            <a href="mailto:a0925122365@gmail.com">a0925122365@gmail.com</a>
          </li>
        </ul>
      </li>
    </ul>
    <Signature />
    <GoTop />
  </div>
</template>

<script>
import Signature from '@/components/Signature.vue'
import GoTop from '@/components/GoTop.vue'

export default {
  name: 'service_p1',
  components: {
    Signature,
    GoTop
  }
}
</script>

<style scoped lang="scss">
/*-----------------------------------------------------------
！手機版！！手機版！！手機版！！小於576px！！手機版！！手機版！！手機版！
------------------------------------------------------------*/
@media screen and (max-width: 576px) {
  #service_p1 {
    h1 {
      text-align: center;
      margin-top: 25px;
    }
    a {
      color: black;
      text-decoration: underline;
    }
    ul {
      font-weight: bold;
      font-size: 15px;
      padding: 20px;
      li {
        list-style-type: decimal;
        list-style-position: inside;
        font-size: 12px;
        font-weight: normal;
        margin-top: 20px;
        #accountInfo {
          li {
            list-style-type: square;
          }
        }
      }
    }
  }
}
/*--------------------------------------------------------
！中間版！中間版！中間版！！577px~991px！！中間版！中間版！中間版！
---------------------------------------------------------*/
@media (min-width: 577px) and (max-width: 991px) {
  #service_p1 {
    h1 {
      text-align: center;
      margin-top: 25px;
    }
    a {
      color: black;
      text-decoration: underline;
    }
    ul {
      font-weight: bold;
      font-size: 20px;
      padding: 30px;
      li {
        list-style-type: decimal;
        list-style-position: inside;
        font-size: 15px;
        font-weight: normal;
        margin-top: 15px;
        margin-left: 20px;
        #accountInfo {
          li {
            list-style-type: square;
          }
        }
      }
    }
  }
}
/*--------------------------------------------------------
！電腦版！！電腦版！！電腦版！！大於992px~1199px！！電腦版！！電腦版！！電腦版！
---------------------------------------------------------*/
@media (min-width: 992px) and (max-width: 1199px) {
  #service_p1 {
    h1 {
      text-align: center;
      margin-top: 25px;
    }
    a {
      color: black;
      text-decoration: underline;
    }
    ul {
      font-weight: bold;
      font-size: 22px;
      padding: 30px;
      li {
        list-style-type: decimal;
        list-style-position: inside;
        font-size: 18px;
        font-weight: normal;
        margin-top: 15px;
        margin-left: 20px;
        #accountInfo {
          li {
            list-style-type: square;
          }
        }
      }
    }
  }
}
/*--------------------------------------------------------
！螢幕版！！螢幕版！！螢幕版！！大於1200px！！螢幕版！！螢幕版！！螢幕版！
---------------------------------------------------------*/
@media screen and (min-width: 1200px) {
  #service_p1 {
    h1 {
      text-align: center;
      margin-top: 25px;
    }
    a {
      color: black;
      text-decoration: underline;
    }
    ul {
      font-weight: bold;
      font-size: 22px;
      padding: 30px;
      li {
        list-style-type: decimal;
        list-style-position: inside;
        font-size: 18px;
        font-weight: normal;
        margin-top: 15px;
        margin-left: 20px;
        #accountInfo {
          li {
            list-style-type: square;
          }
        }
      }
    }
  }
}
</style>
